import TemplateView from "../../TemplateView";
import messageResource from '../../messageResource'
import LoadingSpinner from '../../components/LoadingSpinner'
import {LOAD_COMMENTS_LIMIT} from './constants'

export default class LoadMoreCommentsButton extends TemplateView {
    constructor({
        onClickCb = () => {}
    }) {
        super()

        this.onClickCb = onClickCb

        this.state = {
            loading: false,
        }

        this.onStatePropertyChanged('loading', loading => this._updateLoading(loading))
    }

    templateHtml() {
        return '<div class="loadMoreCommentsButton">' +
               '    <div class="loadMoreBtnTitle"><%=loadMoreBtnTitle%></div>' +
               '    <div class="loadingSpinner"></div>' +
               '</div>'
    }

    templateModel() {
        return {
            loadMoreBtnTitle: messageResource.getMessage('panel.common.comments.load_more_comments')
        }
    }

    afterRender() {
        this.title = this.find('.loadMoreBtnTitle')
        this.loadingSpinner = new LoadingSpinner({}).init(this.find('.loadingSpinner'))

        this.getEl().click(() => {
            if (!this.state.loading) this.onClickCb()
        })
    }

    _updateLoading(loading) {
        this.getEl().toggleClass('disabled', loading)
        this.title.toggle(!loading)
        this.loadingSpinner.setState({show: loading})
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/LoadMoreCommentsButton.js